/**
 * @generated SignedSource<<7048ddfdf66e93b89a94c22e5004ae40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification$data = {
  readonly dailyDueDateNotification: {
    readonly emailChannel: {
      readonly isEnabled: boolean | null | undefined;
    } | null | undefined;
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification";
};
export type emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification$key = {
  readonly " $data"?: emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification$data;
  readonly " $fragmentSpreads": FragmentRefs<"emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification",
  "selections": [
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "dailyDueDateNotification",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "dailyDueDateNotification.id"
        },
        {
          "concreteType": "JiraNotificationChannel",
          "kind": "LinkedField",
          "name": "emailChannel",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isEnabled"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNotificationPreferences"
};

(node as any).hash = "e59131336e89f634651fdc32f297c471";

export default node;
